import React, { useEffect, useState } from "react";
import { InfoRendService } from "../../services";
import {
  Button, Col, ComboBox
} from "@intech/web-ui";
import { HeaderInfoRendEntidade, InfoRendGrupoEntidade } from "@entidades";
import { Grupo } from "./Grupo";
import { LoadingComponent, MasterPage } from "@components";
import { WrapRow, SmallAlert, GrayBox, GreenSpan, Title } from "./styles";

import { NumFuncionalidade } from "../../helpers/BloqueioFuncionalidade";

export const InformeRendimentos: React.FC = (props) => {
  const [AlertText, setAlertText] = useState<string>("");
  const [Datas, setDatas] = useState<Array<number>>(new Array<number>());
  const [Informe, setInforme] = useState<HeaderInfoRendEntidade>();
  const [Referencia, setReferencia] = useState<number>(0);

  useEffect(() => {
    (async () => {
      try {
        const datas = await InfoRendService.BuscarReferencias();

        if (datas.length > 0) {
          setDatas(datas);
          setReferencia(datas[0]);
        }

        if (datas.length === 0) {
          setAlertText("Nenhum informe disponível.");
        }
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }

    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (Referencia > 0) {
          const informe = await InfoRendService.BuscarPorReferencia(Referencia);
          setInforme(informe);
        }
      }
      catch (e) {
        setInforme(undefined);
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }
    })();
  }, [Referencia]);

  async function GerarRelatorio() {
    try {
      const relatorio = await InfoRendService.GerarRelatorio(Referencia, false);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(
          new Blob([relatorio]),
          "Informe de Rendimentos.pdf"
        );
      }
      else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "informe de rendimentos.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  };

  function RenderGrupos() {
    const tempGrupos = Informe!.Grupos.map((grupo: InfoRendGrupoEntidade, index: number) => {
      return (
        <Grupo key={index} grupo={grupo} />
      )
    });
    return tempGrupos;
  };

  function RenderInforme() {
    if (Informe !== undefined) {
      return (
        <>
          <Title>
            Ano Exercício:{" "}
            <GreenSpan>
              {Informe.ANO_EXERCICIO}
            </GreenSpan>
          </Title>
          <Title>
            Ano Calendário:{" "}
            <GreenSpan>
              {Informe.ANO_CALENDARIO}
            </GreenSpan>
          </Title>
          <br />

          {RenderGrupos()}

          <Button
            onClick={GerarRelatorio}
            title={"Gerar Informe de Rendimentos"}
            type={"primary"}
            loadingText={"Baixando..."}
            usesLoading
          />
        </>
      );
    }
  }

  function RenderDados() {
    if (Datas.length > 0) {
      return (
        <WrapRow>
          <Col>
            <GrayBox title={"Resumo"}>
              <div className="mb-3">
                <ComboBox
                  value={Referencia}
                  title={"Calendário"}
                  data={Datas}
                  onChange={setReferencia}
                />
              </div>

              {RenderInforme()}
            </GrayBox>
          </Col>
        </WrapRow>
      );
    }

    if (AlertText !== "") {
      return (
        <SmallAlert type={"danger"}>
          {"Nenhum informe disponível."}
        </SmallAlert>
      );
    }

    return <LoadingComponent />
  };

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.INFORME_DE_RENDIMENTOS_ASSISTIDOS_PENSIONISTAS} {...props}>
      {RenderDados()}
    </MasterPage>
  );
}
